// @ts-nocheck
import { Trans } from '@lingui/react'
import { bool, string } from 'prop-types'
import { FC, ReactElement } from 'react'

import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import ModalShowButton from 'views/components/molecules/ModalShowButton'

import ErxSubstitutionModal from './ErxSubstitutionModal'

const ErxSubstitutionPropTypes = {
  modalId: string.isRequired,
  originalName: string.isRequired,
  replacedName: string.isRequired,
  openModal: bool,
  className: string,
}

const ErxSubstitutionDefaultProps = {
  openModal: false,
  className: undefined,
}

export type ErxSubstitutionProps = InferPropsWithDefaults<
  typeof ErxSubstitutionPropTypes,
  typeof ErxSubstitutionDefaultProps
>

const ErxSubstitution: FC<ErxSubstitutionProps> = ({
  modalId,
  originalName,
  replacedName,
  openModal,
  className,
}): ReactElement => {
  return (
    <>
      <div className={className}>
        <span className="u-color--grey o-ErxSubstitution__text">
          <Trans id="account.orders.details.swappedErxProduct" />
        </span>{' '}
        <ModalShowButton
          component={ButtonTransparent}
          name={`swapped-product-modal`}
          small
          className={'o-ErxSubstitution__button'}
          modalId={modalId}
          inline
        >
          <IconCircleInfoOutline size="small" />
        </ModalShowButton>
      </div>

      <ErxSubstitutionModal
        modalId={modalId}
        originalName={originalName}
        replacedName={replacedName}
        open={openModal}
      />
    </>
  )
}

ErxSubstitution.propTypes = ErxSubstitutionPropTypes
ErxSubstitution.defaultProps = ErxSubstitutionDefaultProps

export default ErxSubstitution
